<template>
    <div v-if="!showOptionSetting">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_map_image_overlay_setting'"></div>
        </div>
        <div class="object-inner-table">
            <table width="100%">
                <tr><td style="width:50%" class="object-item" v-t="'message.info_not_available_for_this_tenant'"></td></tr>
            </table>
        </div>
    </div>
    <div v-else>
        <div class="object-titlebox">
            <div class="title-box-left">
                <span v-t="'message.item_map_image_overlay_setting'"></span>
                <div class="title-box-right">
                    <button class="transparent" type="button" @click="addMapImageOverlay()"><img src="@/assets/add_user.svg" alt=""/><span class="normal-command-text" v-t="'message.common_action_add'"></span></button>
                </div>
            </div>
        </div>
        <table width="100%">
            <tr class="overlay-title">
                <td class="object-item1" style="width:70%" v-t="'message.item_map_image_overlay_display_name'"></td>
                <td class="object-item2" v-t="'message.item_group'"></td>
                <td class="object-item2" v-t="'message.common_action_edit'"></td>
                <td class="object-item2" v-t="'message.common_action_delete'"></td>
            </tr>
            <tr class="overlay-record" v-for="mapImageOverlayInfo in mapImageOverlayInfoList" :key="mapImageOverlayInfo.id">
                <td class="object-item1" style="width:70%">
                    {{ mapImageOverlayInfo.name }}
                </td>
                <td class="object-item2">
                    <button class="transparent" type="button" @click="assignMapImageOverlay(mapImageOverlayInfo)"><span class="normal-command-text" v-t="'message.action_assign'"></span></button>
                </td>
                <td class="object-item2">
                    <button class="transparent" type="button" @click="editMapImageOverlay(mapImageOverlayInfo)"><img src="@/assets/edit.svg" alt=""/></button>
                </td>
                <td class="object-item2">
                    <button class="transparent" type="button" @click="deleteMapImageOverlay(mapImageOverlayInfo)"><img src="@/assets/delete.svg" alt=""/></button>
                </td>
            </tr>
        </table>
        <addMapImageOverlay v-if="showMapImageOverlayDialog.add" @validateMapImageOverlayNameDuplicated="validateMapImageOverlayNameDuplicated" :appData="$root.store.appData" :add="true" @save="doAddMapImageOverlay" @cancel="showMapImageOverlayDialog.add=false"></addMapImageOverlay>
        <assignMapImageOverlay v-if="showMapImageOverlayDialog.assign" :tenantId="$root.store.tenantId" :baseMapImageOverlayInfo="selectedMapImageOverlayInfo" @save="doAssignMapImageOverlay" @cancel="showMapImageOverlayDialog.assign=false"></assignMapImageOverlay>
        <editMapImageOverlay v-if="showMapImageOverlayDialog.edit" @validateMapImageOverlayNameDuplicated="validateMapImageOverlayNameDuplicated" :baseMapImageOverlayInfo="selectedMapImageOverlayInfo" :appData="$root.store.appData" :edit="true" @save="doEditMapImageOverlay" @cancel="showMapImageOverlayDialog.edit=false" @nochange="handleNoChangeEdit"></editMapImageOverlay>
        <deleteMapImageOverlay v-if="showMapImageOverlayDialog.delete" :confirmInfo="confirmInfo" @delete="doDeleteMapImageOverlay" @cancel="showMapImageOverlayDialog.delete=false"></deleteMapImageOverlay>
    </div>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import MapImageOverlayAssignToTalkGroup from "@/components/pc/setting/mapImageOverlay/MapImageOverlayAssignToTalkGroup";
import MapImageOverlayEdit from "@/components/pc/setting/mapImageOverlay/MapImageOverlayEdit";
import DeleteObject from "../../../DeleteObject.vue";

export default {
    components: {
        addMapImageOverlay: MapImageOverlayEdit,
        assignMapImageOverlay: MapImageOverlayAssignToTalkGroup,
        editMapImageOverlay: MapImageOverlayEdit,
        deleteMapImageOverlay: DeleteObject,
    },
    data() {
        return {
            showMapImageOverlayDialog: {
                add: false,
                assign: false,
                edit: false,
                delete: false,
            },
            maxMapImageOverlayCount: 0,
            mapImageOverlayInfoList: [],
            selectedMapImageOverlayInfo: null,
            confirmInfo: {
                objectName: null,
                objectTitle: null,
            }
        };
    },
    computed: {
        showOptionSetting: function() {
            return this.$root.store.appData.enableSpeechTextOption || this.$root.store.appData.enableSpeechTextTrial;
        }
    },
    created: function() {
        if (this.showOptionSetting) {
            this.getMapImageOverlayList();
        }
    },
    methods: {
        getMapImageOverlayList: function() {
            server.post('/getmapimageoverlaylist', {})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.mapImageOverlayInfoList = res.data.mapImageOverlayInfoList;
                            this.maxMapImageOverlayCount = res.data.maxMapImageOverlayCount;
                            break;
                        default:
                            commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","getMapImageOverlayList").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(this, "getMapImageOverlayList", error);
                });
        },
        addMapImageOverlay() {
            if (this.mapImageOverlayInfoList.length >= this.maxMapImageOverlayCount) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_exceeds_max_count").replace("{maxMapImageOverlayCount}",this.maxMapImageOverlayCount));
                return;
            }
            this.selectedMapImageOverlayInfo = null;
            this.showDialogAfterWritableCheck("add");
        },
        assignMapImageOverlay(mapImageOverlayInfo) {
            this.selectedMapImageOverlayInfo = mapImageOverlayInfo;
            this.showDialogAfterWritableCheck("assign");
        },
        editMapImageOverlay(mapImageOverlayInfo) {
            this.selectedMapImageOverlayInfo = mapImageOverlayInfo;
            this.showDialogAfterWritableCheck("edit");
        },
        deleteMapImageOverlay(mapImageOverlayInfo) {
            this.selectedMapImageOverlayInfo = mapImageOverlayInfo;
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "title_map_image_overlay");
            this.confirmInfo.objectName = mapImageOverlayInfo.name;
            this.showDialogAfterWritableCheck("delete");
        },
        doAddMapImageOverlay(mapImageOverlayParams) {
            if (!mapImageOverlayParams || !mapImageOverlayParams.file) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_image_file_required"));
                return;
            }

            const param = {
                name: mapImageOverlayParams.name,
                opacity: mapImageOverlayParams.opacity,
                zIndex: mapImageOverlayParams.zIndex ?? 0,
                underLeftLat: Number(mapImageOverlayParams.underLeftLat),
                underLeftLng: Number(mapImageOverlayParams.underLeftLng),
                topRightLat: Number(mapImageOverlayParams.topRightLat),
                topRightLng: Number(mapImageOverlayParams.topRightLng),
            };

            const fd = new FormData();
            fd.append("parameter", JSON.stringify(param));

            const namedAdd = this.ensureNamedFile(mapImageOverlayParams.file);
            if (!namedAdd) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_image_file_invalid"));
                return;
            }
            fd.append("file", namedAdd, namedAdd.name);

            server.post('/createmapimageoverlay', fd)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.getMapImageOverlayList();
                            commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "info_created_map_image_overlay"));
                            break;
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_invalid_params"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_layer_already_changed"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_name_already_exist"));
                            break;
                        case constants.STATUS_ERROR_STORAGE:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_storage_upload_failed"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_exceeds_max_count").replace("{maxMapImageOverlayCount}", res.data.maxMapImageOverlayCount));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_SIZE:
                            const maxOverlaySizeBytes = res.data.maxSingleMapImageOverlaySizeBytes;
                            const maxOverlayFileSizeMB = (maxOverlaySizeBytes / (1024 * 1024)).toFixed(1);
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_file_too_large").replace("{maxOverlayFileSizeMB}", maxOverlayFileSizeMB));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_STORAGE_CAPACITY:
                            const maxOverlayCount = res.data.maxMapImageOverlayStorageUsageCount;
                            const totalOverlayCapacityMB = (maxOverlayCount / (1024 * 1024)).toFixed(1);
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_storage_exceeds_max_capacity").replace("{maxSizeMB}", totalOverlayCapacityMB));
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "doAddMapImageOverlay").replace("{code}", res.data.status));
                            break;
                    }
                    this.showMapImageOverlayDialog.add = false;
                })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(this, "doAddMapImageOverlay", error);
                    this.showMapImageOverlayDialog.add = false;
                });
        },
        doAssignMapImageOverlay(input) {
            const operations = [];
            for (const key in input.addTagList) operations.push({ operation: 1, talkGroupId: input.addTagList[key].talkgroupId });
            for (const key in input.removeTagList) operations.push({ operation: -1, talkGroupId: input.removeTagList[key].talkgroupId });

            if (operations.length === 0) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                this.showMapImageOverlayDialog.assign = false;
                return;
            }

            server.post('/modifymapimageoverlayassignment', {mapImageOverlayId: this.selectedMapImageOverlayInfo.id, operationDataList: operations})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "info_assign_map_image_overlay_layer"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(this,"Error", commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_layer_already_changed"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_MAP_IMAGE_OVERLAY_PER_GROUP:
                            commonUtil.notifyMessage(this,"Error", commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_group_exceeds_max_count").replace("{maxMapImageOverlayCount}", res.data.maxMapImageOverlayCount));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_GROUPS_PER_MAP_IMAGE_OVERLAY:
                            commonUtil.notifyMessage(this,"Error", commonUtil.getMessageText(this.$i18n,"error_overlay_group_assign_limit_exceeded").replace("{maxGroupsPerOverlayCount}", res.data.maxGroupsPerOverlayCount));
                            break;
                        default:
                            commonUtil.notifyMessage(this,"Error", commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","doAssignMapImageOverlay").replace("{code}",res.data.status));
                            break;
                    }
                    this.showMapImageOverlayDialog.assign = false;
                })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(this,"doAssignMapImageOverlay",error);
                    this.showMapImageOverlayDialog.assign = false;
                });
        },
        doEditMapImageOverlay(mapImageOverlayParams, baseMapImageOverlayInfo) {
            const param = {
                id: baseMapImageOverlayInfo.id,
                name: mapImageOverlayParams.name ?? baseMapImageOverlayInfo.name,
                objectKey: mapImageOverlayParams.objectKey ?? baseMapImageOverlayInfo.objectKey,
                opacity: mapImageOverlayParams.opacity ?? baseMapImageOverlayInfo.opacity,
                zIndex: mapImageOverlayParams.zIndex ?? baseMapImageOverlayInfo.zIndex,
                underLeftLat: Number(mapImageOverlayParams.underLeftLat ?? baseMapImageOverlayInfo.underLeftLat),
                underLeftLng: Number(mapImageOverlayParams.underLeftLng ?? baseMapImageOverlayInfo.underLeftLng),
                topRightLat: Number(mapImageOverlayParams.topRightLat ?? baseMapImageOverlayInfo.topRightLat),
                topRightLng: Number(mapImageOverlayParams.topRightLng ?? baseMapImageOverlayInfo.topRightLng),
            };

            const fd = new FormData();
            fd.append("parameter", JSON.stringify(param));

            if (mapImageOverlayParams && mapImageOverlayParams.file) {
                const namedEdit = this.ensureNamedFile(mapImageOverlayParams.file);
                if (namedEdit) {
                    fd.append("file", namedEdit, namedEdit.name);
                }
            }

            server.post('/updatemapimageoverlay', fd)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.getMapImageOverlayList();
                            commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "info_modified_map_image_overlay"));
                            break;
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_invalid_params"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_layer_already_changed"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_name_already_exist"));
                            break;
                        case constants.STATUS_ERROR_STORAGE:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_storage_upload_failed"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_SIZE:
                            const maxOverlaySizeBytes = res.data.maxSingleMapImageOverlaySizeBytes;
                            const maxOverlayFileSizeMB = (maxOverlaySizeBytes / (1024 * 1024)).toFixed(1);
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_file_too_large").replace("{maxOverlayFileSizeMB}", maxOverlayFileSizeMB));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_STORAGE_CAPACITY:
                            const maxOverlayCount = res.data.maxMapImageOverlayStorageUsageCount;
                            const totalOverlayCapacityMB = (maxOverlayCount / (1024 * 1024)).toFixed(1);
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_storage_exceeds_max_capacity").replace("{maxSizeMB}", totalOverlayCapacityMB));
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "doEditMapImageOverlay").replace("{code}", res.data.status));
                        break;
                    }
                    this.showMapImageOverlayDialog.edit = false;
                })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(this, "doEditMapImageOverlay", error);
                    this.showMapImageOverlayDialog.edit = false;
                });
        },
        doDeleteMapImageOverlay() {
            server.post('/deletemapimageoverlay', {mapImageOverlayId: this.selectedMapImageOverlayInfo.id})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.getMapImageOverlayList();
                            commonUtil.notifyMessage(this,"Success", commonUtil.getMessageText(this.$i18n,"info_deleted_map_image_overlay"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(this,"Error", commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_already_changed"));
                            break;
                        case constants.STATUS_ERROR_STILL_ASSIGNED:
                            commonUtil.notifyMessage(this,"Error", commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_cannot_delete_still_asigined_layer"));
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "doDeleteMapImageOverlay").replace("{code}", res.data.status));
                            break;
                    }
                    this.showMapImageOverlayDialog.delete = false;
                })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(this,"doDeleteMapImageOverlay",error);
                    this.showMapImageOverlayDialog.delete = false;
                });
        },
        showDialogAfterWritableCheck(command) {
            if (!this.$root.store.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_operate_no_tenantAdmin_privilege"));
                return;
            }
            this.showMapImageOverlayDialog[command] = true;
        },
        validateMapImageOverlayNameDuplicated(name, callback){
            for (let overlay of this.mapImageOverlayInfoList) {
                if (overlay.name === name) {
                    callback(false, commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_name_already_exist"));
                    return;
                }
            }
            callback(true, null);
        },
        mimeToExt(mime) {
            if (!mime) return 'bin';
            const m = mime.toLowerCase();
            if (m.includes('png')) return 'png';
            if (m.includes('jpeg') || m.includes('jpg')) return 'jpg';
            if (m.includes('gif')) return 'gif';
            if (m.includes('webp')) return 'webp';
            if (m.includes('tiff')) return 'tif';
            if (m.includes('heic')) return 'heic';
            return 'bin';
        },
        extToMime(ext) {
            switch ((ext || '').toLowerCase()) {
                case 'png': return 'image/png';
                case 'jpg':
                case 'jpeg': return 'image/jpeg';
                case 'gif': return 'image/gif';
                case 'webp': return 'image/webp';
                case 'tif':
                case 'tiff': return 'image/tiff';
                case 'heic': return 'image/heic';
                default: return 'application/octet-stream';
            }
        },
        ensureNamedFile(blobOrFile) {
            if (!blobOrFile) return null;
            if (!(blobOrFile instanceof Blob)) return null;
            if (blobOrFile instanceof File && blobOrFile.name && /\.[A-Za-z0-9]+$/.test(blobOrFile.name)) {
              return blobOrFile;
            }
            const mime = blobOrFile.type || '';
            const ext  = this.mimeToExt(mime);
            const name = `overlay_${Date.now()}.${ext}`;
            const type = mime || this.extToMime(ext);
            return new File([blobOrFile], name, { type });
        },
        handleNoChangeEdit() {
            this.showMapImageOverlayDialog.edit = false;
            this.$nextTick(() => {
                commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
            });
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}
.title-box-left {
    padding: 10px 10px 10px 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.object-item1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    font-size: 12px;
}
.object-item2 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 28px;
    font-size: 12px;
    width: 10%;
    text-align: right;
}
.overlay-title {
    background-color: #f6f6f6;
    color: #848991;
}
.overlay-record {
    background-color:transparent;
    border-bottom: solid 1px #eee;
}
button.transparent img {
    display: inline;
    vertical-align: middle;
    height: 18px;
}

</style>
